import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { useStyles } from "./SliderDots.style";

interface ISliderDotsProps {
  listLength: number;
  activeDot?: number;
  isHideGamepad?: boolean;
  onDotClick?: (index: number) => void;
}

export const SliderDots: FC<
  ISliderDotsProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { listLength, activeDot, isHideGamepad, onDotClick, ...otherProps } =
    props;

  return (
    <div {...otherProps} className={clsx(classes.root, otherProps.className)}>
      {Array.from({ length: listLength }, (_, index) => (
        <div
          key={index}
          className={clsx(classes.dot, activeDot === index && "active")}
          onClick={() => onDotClick?.(index)}
        />
      ))}
    </div>
  );
};
